import React from 'react';

import { IconButton, Typography } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';

import useStyles from './ManagePageHeader.styles';

type Props = {
  children: React.ReactNode;
  subtitle?: string | React.ReactNode;
  noBorder?: boolean;
  className?: string;
  backButton?: boolean;
  rightAdornment?: React.ReactNode;
  bottomAdornment?: React.ReactNode;
  onBack?: () => void | Promise<void>;
};

const ManagePageHeader: React.FC<Props> = ({
  children,
  backButton = false,
  subtitle,
  rightAdornment,
  noBorder,
  bottomAdornment,
  className,
  onBack: customOnBack,
}) => {
  const styles = useStyles({ noBorder: !!noBorder });
  const history = useHistory();
  const onBack =
    customOnBack ||
    (() => {
      history.goBack();
    });
  return (
    <header className={clsx(styles.header, className)}>
      <div className={styles.headerLeft}>
        {backButton && (
          <IconButton className={styles.backButton} onClick={onBack} size='small'>
            <ArrowBack />
          </IconButton>
        )}
        <div>
          <Typography component='h1' variant='h2'>
            {children}
          </Typography>
          {subtitle && <Typography className={styles.subtitle}>{subtitle}</Typography>}
          {bottomAdornment || null}
        </div>
      </div>
      {rightAdornment && <div className={styles.rightAdornment}>{rightAdornment}</div>}
    </header>
  );
};

export default ManagePageHeader;
